import { isRelativeUrl } from 'site-modules/shared/utils/is-relative-url';

export function isLinkWithSameOrigin(href) {
  const linkHref = href.replace('https://www.edmunds.com', '');
  return !!linkHref && (isRelativeUrl(linkHref) || linkHref.startsWith(window.origin));
}
